// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container[data-v-4b4511b9]{text-align:center}span[data-v-4b4511b9]{font-family:Rubik,sans-serif;font-weight:500}.input-date[data-v-4b4511b9]{margin-left:auto;margin-right:auto;margin-top:16px;margin-bottom:16px;width:10rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
